export default "/bundles/assets/notification_b9cbbbeb6e896d8f6d64b809067f6284.png";